import { Modal, Input, Select, Button } from 'antd'
import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { CloseOutlined } from '@ant-design/icons'
import {
	fetchItemsGroups,
	fetchUoMGroups,
	fetchItemsModalServices,
} from '@utils/fetchData'
import { useQuery } from '@tanstack/react-query'
import { http } from '@services/http'
import SuccessModal from './SuccessModal'
import ErrorModal from './ErrorModal'
import { formatNumberWithSpaces, removeSpaces } from '@utils/numberWithSpaces'
const EditShapesTableModal = ({
	visible,
	data,
	onClose,
	onClick,
	finish = false,
	onSuccess = () => {},
}) => {
	const { t } = useTranslation()

	const successRef = useRef()
	const errorRef = useRef()

	const [loading, setLoading] = useState('')
	const [itemName, setItemName] = useState('')
	const [width, setWidth] = useState('')
	const [height, setHeight] = useState('')
	const [quantity, setQuantity] = useState('')
	const [price, setPrice] = useState('')
	const [currency, setCurrency] = useState('')
	const [itmsGrp, setItmsGrp] = useState('')
	const [ugpName, setUgpName] = useState('')
	const [timer, setTimer] = useState('')
	const [u_Number, setUNumber] = useState('')
	const [modal, setModal] = useState('')

	useEffect(() => {
		if (data) {
			setItemName(data.itemName)
			setWidth(data.u_Width ?? '')
			setHeight(data.u_Height ?? '')
			setQuantity(data.u_Kvmetr ?? '')
			setPrice(parseFloat(data.price) ?? '')
			setCurrency(data.currency ?? '')
			setItmsGrp(data.itmsGrpCod ?? '')
			setUgpName(data.ugpEntry ?? '')
			setTimer(data.u_Timer ?? '')
			setUNumber(data.u_Number ?? '')
			setModal(data.u_Modal ?? '')
		}
	}, [data, visible])

	const { data: itemsGroupData = [], isLoading: itemsLoading } = useQuery({
		queryKey: ['itemsGrp'],
		queryFn: fetchItemsGroups,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: modalServiceData = [] } = useQuery({
		queryKey: ['modalService'],
		queryFn: fetchItemsModalServices,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const {
		data: uomData = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['uoMEntry'],
		queryFn: fetchUoMGroups,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const postData = async () => {
		setLoading(true)

		try {
			await http.patch(`api/items/${data.itemCode}`, {
				itemName,
				itemsGroupCode: itmsGrp,
				u_Width: width.toString(),
				u_Height: height.toString(),
				u_Kvmetr: quantity.toString(),
				uoMGroupEntry: ugpName,
				u_Modal: modal,
				u_ServiceGroup: data?.u_ServiceGroup,
				u_Timer: timer,
				u_Number: u_Number.toString(),
			})
			successRef.current.open(t('sucEdited'))
			resetForm()
			onSuccess?.()
		} catch (error) {
			errorRef.current.open(error?.response?.data?.message)
		} finally {
			setLoading(false)
		}
	}

	const resetForm = () => {
		setLoading(false)
		setItemName('')
		setWidth('')
		setHeight('')
		setQuantity('')
		setPrice('')
		setCurrency('')
		setItmsGrp('')
		setUgpName('')
		setTimer('')
		setUNumber('')
		setModal('')
	}

	if (!data) return null

	return (
		<Modal
			title={
				<h1 className="font-nunito text-xl font-extrabold text-[#000000]">
					{t('infoItem')}
				</h1>
			}
			open={visible}
			onCancel={onClose}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="50%"
			style={{ height: '80%' }}
			bodyStyle={{ height: 'calc(100% - 55px)', overflowY: 'auto' }}
		>
			<div className="w-full px-4 sm:px-5">
				<div className="w-full">
					<div className="mt-10 flex flex-col items-center gap-5 justify-between sm:flex-row">
						<div className="flex flex-col gap-3">
							<p className="font-nunito">{t('itemName')}</p>
							<Input
								type="text"
								value={itemName}
								className="flex h-10  w-full items-center justify-center "
								style={{ color: 'black' }}
								onChange={(e) => {
									setItemName(e.target.value)
								}}
							/>
						</div>
						<div className=" flex flex-col gap-3 ">
							<p>{`${t('serviceType')}`}</p>
							<Select
								type="text"
								value={modal}
								onChange={(val) => {
									setModal(val)
								}}
								className="flex h-10 w-[200px]  items-center justify-center border-[#D0D0D0]"
								options={modalServiceData.map((item) => ({
									label: item.descr,
									value: item.fldValue,
								}))}
							/>
						</div>
						<div className="mt-4 flex flex-col gap-3 sm:mt-0">
							<p className="font-nunito">{t('productGroup')}</p>

							<Input
								type="text"
								value={data?.itmsGrpNam}
								className="flex h-10  w-full items-center justify-center "
								style={{ color: 'black' }}
								disabled
							/>
						</div>
					</div>

					<div className="mt-10 flex flex-col items-end gap-7  justify-between sm:flex-row">
						<div className="flex flex-col gap-3 w-full">
							<p className="font-nunito">{`${t('u_Number')} `}</p>
							<Input
								type="text"
								value={u_Number}
								className="flex h-10 w-auto items-center justify-center"
								style={{ color: 'black' }}
								onChange={(e) => {
									setUNumber(e.target.value)
								}}
							/>
						</div>
						<div className="flex flex-col  gap-3 w-full">
							<p className="font-nunito text-center">{`${t('timerItem')}`}</p>
							<Input
								value={timer}
								className="flex h-10 w-auto items-center justify-center"
								style={{ color: 'black' }}
								onChange={(e) => {
									setTimer(e.target.value)
								}}
							/>
						</div>
						<div className=" flex flex-col gap-3 w-full">
							<p>{`${t('unitMsr')}`}</p>
							<Select
								type="text"
								value={ugpName}
								onChange={(val) => {
									setUgpName(val)
								}}
								className="flex h-10 w-full  items-center justify-center border-[#D0D0D0]"
								options={uomData.map((item) => ({
									label: item.ugpName,
									value: item.ugpEntry,
								}))}
								disabled
							/>
						</div>
					</div>

					<div className="flex items-center gap-10 mt-14 justify-end">
						<Button
							onClick={postData}
							loading={loading}
							disabled={loading}
							className="w-auto bg-[#0A4D68] h-[35px] rounded-lg text-white"
						>
							{t('save')}
						</Button>
					</div>
				</div>
			</div>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
				onConfirm={() => onClose()}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</Modal>
	)
}

export default EditShapesTableModal
